/**
 *  获取四舍五入的值-以解决四舍五入精度问题
 * @param {Object} value
 * @param {Object} how
 */
const fNumRound = (value, how) => {
	let num = new Number(value);
	let num1 = new Number(num.toFixed(10));
	return parseFloat(num1.toFixed(how));
};

/**
 * @Description: 解决JS计算浮点加法时的精度问题
 * @errorExample: 0.7+0.1
 * @param arg1
 * @param arg2
 * @return
 */
const fNumAdd = (arg1, arg2) => {
	let r1 = 0;
	let r2 = 0;
	let m = 0;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}

	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}

	m = Math.pow(10, Math.max(r1, r2));
	return (arg1 * m + arg2 * m) / m;
};

/**
 * @Description: 解决JS计算浮点减法时的精度问题
 * @errorExample: 0.3/0.1
 * @param arg1
 * @param arg2
 * @return
 */
const fNumDesc = (arg1, arg2) => {
	let r1 = 0;
	let r2 = 0;
	let m = 0;
	let n = 0;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	n = (r1 >= r2) ? r1 : r2;
	return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

/**
 * @Description: 解决JS计算浮点乘法时的精度问题
 * @errorExample: 0.045 * 1293.00
 * @param arg1
 * @param arg2
 * @return
 */
const fNumMul = (arg1, arg2) => {
	let m = 0;
	let s1 = arg1.toString();
	let s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length;
	} catch (e) {}

	try {
		m += s2.split(".")[1].length;
	} catch (e) {}

	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};



/**
 * @Description: 解决JS计算浮点除法时的精度问题
 * @errorExample: 0.3/0.1
 * @param arg1
 * @param arg2
 * @return
 */
const fNumDiv = (arg1, arg2) => {
	let t1 = 0;
	let t2 = 0;
	let r1 = 0;
	let r2 = 0;
	try {
		t1 = arg1.toString().split(".")[1].length;
	} catch (e) {}
	try {
		t2 = arg2.toString().split(".")[1].length;
	} catch (e) {}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	return (r1 / r2) * Math.pow(10, t2 - t1);
};

// 金额格式化
const fMoneyFat = (value, decimalPlaces = 2) => {
  value = Number(value) - 0
	if (!value && value !== 0) return '-';
	var intPart = Number(value) | 0; //获取整数部分
	var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1'); //将整数部分逢三一断

	// 根据指定的小数位数格式化
	if (decimalPlaces >= 0) {
		return Number(value).toFixed(decimalPlaces);
	}
	
	// 默认行为保持向后兼容
	var floatPart = ".00"; //预定义小数部分
	var value2Array = value.toString().split(".");
	//=2表示数据有小数位
	if (value2Array.length == 2) {

		floatPart = value2Array[1].toString(); //拿到小数部分
    
		if(floatPart.length >= 4){
			// return intPart.toString() + "." + floatPart.slice(0,2);
      return Number(value).toFixed(4)
		}
    if(floatPart.length == 3){
      return Number(value).toFixed(3)
    }
    if(floatPart.length == 2){
      return Number(value).toFixed(2)
    }
		if (floatPart.length == 1) { //补0,实际上用不着
			return intPart.toString() + "." + floatPart + '0';
		} else {
			return intPart.toString() + "." + floatPart;
		}
	} else {
		return intPart.toString() + floatPart;
	}
};

// 判断数字（包含正负整数，0以及正负浮点数）如果是数字返回输入，不是返回 ''
const fIsNum = (arg) => {
	arg = arg.toString();
	let argChar = '0123456789.';
	let pointNum = 0;

	if (arg.length < 1) return '0';

	//如果第一个字符是0 截取  从第二个字符开始（包含）
	if (arg.charAt(0) == '0' && arg.charAt(0) != '.')
		arg = arg.substring(1);

	//如果第一个字符是 .
	if (arg.charAt(0) == '.')
		arg = '0' + arg;

	for (let i = 0; i < arg.length; i++) {
		if (arg.substring(i, i + 1) == '.') pointNum = pointNum + 1;
		if (argChar.indexOf(arg.substring(i, i + 1)) == -1) return '';
	};

	if (pointNum > 1) return '';
	return arg;
};

export default {

	fNumAdd, //加
	fNumDesc, //减
	fNumMul, //乘
	fNumDiv, //除
	fNumRound, //四舍五入

	fMoneyFat, //金额格式化
	fIsNum,// 判断数字（包含正负整数，0以及正负浮点数）如果是数字返回输入，不是返回 ''

};



//////////////////
// WEBPACK FOOTER
// ./common/global/numHelper.js
// module id = null
// module chunks = 